/**
 * Unsubscribe API wrappers — talks to /api/unsubscribe/*
 */
import api from './api';

export const unsubscribeApi = {
  listCampaigns: () => api.get('/unsubscribe/campaigns'),
  getConfig: () => api.get('/unsubscribe/config'),
  updateConfig: (payload) => api.put('/unsubscribe/config', payload),
  apply: (payload) => api.post('/unsubscribe/apply', payload),
  listAudits: (params = {}) => api.get('/unsubscribe/audits', { params }),
  listContactAudits: (contactId, params = {}) => api.get(`/unsubscribe/audits/by-contact/${contactId}`, { params }),
  testConnection: () => api.post('/unsubscribe/test-connection'),
  testLookup: (payload) => api.post('/unsubscribe/test-lookup', payload),
};

export default unsubscribeApi;
